import { Box } from "@mui/material";

export function HoverContainer(props: { onClick: () => void }) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        height: "100%",
        cursor: "pointer",
      }}
      onClick={props.onClick}
    />
  );
}
